import React from "react";
import styled from "styled-components";
import { motion, useScroll, useSpring } from "framer-motion";

const BarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: transparent;
  z-index: 9999;
  pointer-events: none;
`;

const Bar = styled(motion.div)`
  height: 100%;
  background: linear-gradient(90deg, #06b6d4, #8b5cf6, #ec4899);
  box-shadow: 0 0 12px #06b6d4, 0 0 24px rgba(139, 92, 246, 0.7);
  transform-origin: 0%;
`;

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 200,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <BarWrapper>
      <Bar style={{ scaleX }} />
    </BarWrapper>
  );
};

export default ScrollProgress;
